// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app/components/static/AuditTool/Opengraph/MetatagsCards/Facebook.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app/components/static/AuditTool/Opengraph/MetatagsCards/Facebook.tsx");
  import.meta.hot.lastModified = "1717182690460.1714";
}
// REMIX HMR END

export function Facebook({
  title,
  description,
  image,
  origin
}) {
  return <div id="facebook">
      <div className="card-facebook mt-[13px] min-[770px]:w-[500px] cursor-pointer">
        <div className="card-facebook-image min-[770px]:h-[261px] min-[770px]:w-[500px] h-[180px] border border-gray-300 bg-contain bg-center bg-cover" style={{
        backgroundImage: `url("${image}")`
      }}></div>
        <div className="border-x border-b border-gray-300 px-3 py-[10px] bg-[#f2f3f5] text-[#606770] text-[12px] leading-3">
          <span>{origin.toUpperCase()}</span>
          <p className="text-base mt-1 text-[#1d2129] font-semibold leading-[22px] break-words">
            {title}
          </p>
          <span className="text-sm leading-[18px] mt-1 mb-1 text-black hidden min-[770px]:block break-words" dangerouslySetInnerHTML={{
          __html: description
        }} />
        </div>
      </div>
    </div>;
}
_c = Facebook;
var _c;
$RefreshReg$(_c, "Facebook");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;